module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v("\n    " + _vm._s(_vm.startDate) + " (" + _vm._s(_vm.startTime) + ")\n\n    "), (_vm.startDate != _vm.endDate) ? _c('span', [_vm._v("\n        to " + _vm._s(_vm.endDate) + " (" + _vm._s(_vm.endTime) + ")\n    ")]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-31f3f7c4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f3f7c4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/DateAndTime.vue
// module id = 1713
// module chunks = 0